import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { getNovaPrice } from "../service/main/api";

const toNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const toStringValue = (value) => {
  if (value === null || value === undefined) return "0";
  if (typeof value === "string") return value;
  return String(value);
};

const useNovaPrice = () => {
  const query = useQuery({
    queryKey: ["novaPrice"],
    queryFn: async () => {
      const res = await getNovaPrice();
      if (!res?.success) {
        throw new Error(res?.message || "Failed to fetch NOVA price");
      }
      return res.data;
    },
    staleTime: 30_000,
    refetchInterval: 60_000,
    retry: 1,
  });

  const priceString = useMemo(() => toStringValue(query.data), [query.data]);
  const priceNumber = useMemo(() => toNumber(priceString), [priceString]);

  return {
    priceString,
    priceNumber,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
};

export default useNovaPrice;
